<ef-loading [loading]="IsLoading"></ef-loading>

<div style="display: flex">
    <p-dialog header="New Manual Adjustment" [(visible)]="this.showDialog" [maximizable]="false" [closable]="false"
        [closeOnEscape]="false" [style]="{ 'min-width': '40em ' }">
        <form [formGroup]="addFormGroup" #addForm="ngForm" id="addForm">
            <div class="flex justify-content-center mt-3 mb-3">
                <div class="flex items-center mr-2">
                    <p-radioButton name="direct" value="direct" formControlName="direct" inputId="direct">
                    </p-radioButton>
                    <label class="radio-label" for="direct">Direct</label>
                </div>
                <div class="flex items-center">
                    <p-radioButton name="indirect" value="indirect" formControlName="indirect" inputId="indirect">
                    </p-radioButton>
                    <label class="radio-label" for="indirect">Indirect</label>
                </div>
            </div>

            <!-- As of Date -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-datepicker [monthNavigator]="true" [yearNavigator]="true" yearRange="2000:2030" appendTo="body"
                        [showIcon]="false" id="asofdate" formControlName="Asofdate" [style]="{ width: '100%' }"
                        [minDate]="CSFYStart" [maxDate]="CSFYEnd">
                    </p-datepicker>
                    <label *ngIf="asOfDateIsRequired == true" style="color: red" for="float-dd">As of Date</label>
                    <label *ngIf="asOfDateIsRequired == false" for="float-dd">As of Date</label>
                </p-floatLabel>
            </div>

            <!-- Contract -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-select [options]="contractsSelectItem" [filter]="true" appendTo="body"
                        [autoDisplayFirst]="false" formControlName="Contracts" [style]="{ width: '100%' }">
                    </p-select>
                    <label *ngIf="contractIsRequired == true" style="color: red" for="float-dd">Contract</label>
                    <label *ngIf="contractIsRequired == false" for="float-dd">Contract</label>
                </p-floatLabel>
            </div>

            <!-- Task -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-multiSelect maxSelectedLabels="1" appendTo="body"
                        [options]="tasksSelectItem" [filter]="true" formControlName="Tasks" [style]="{ width: '100%' }">
                    </p-multiSelect>
                    <label *ngIf="taskIsRequired == true" style="color: red" for="float-dd">Task</label>
                    <label *ngIf="taskIsRequired == false" for="float-dd">Task</label>
                </p-floatLabel>
            </div>

            <!-- Txn Type -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-select [options]="txnTypesSelectItem" [filter]="true" appendTo="body"
                        [autoDisplayFirst]="false" formControlName="Txntypes" [style]="{ width: '100%' }">
                    </p-select>
                    <label *ngIf="txnTypeIsRequired == true" style="color: red" for="float-dd">Txn Type</label>
                    <label *ngIf="txnTypeIsRequired == false" for="float-dd">Txn Type</label>
                </p-floatLabel>
            </div>

            <!-- Cost Center -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on" *ngIf="this.userGroups?.length > 1">
                    <p-multiSelect
                        appendTo="body"
                        [options]="userGroupsSelectItem"
                        [filter]="true"
                        formControlName="CC"
                        [style]="{ width: '100%' }"
                        [styleClass]="ccIsRequired ? 'required-invalid' : ''"
                    >
                    </p-multiSelect>
                    <label *ngIf="ccIsRequired == true" style="color: red" for="float-dd">Cost Center</label>
                    <label *ngIf="ccIsRequired == false" for="float-dd">Cost Center</label>
                </p-floatLabel>
            </div>

            <!-- Item -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-multiSelect [options]="serviceItemsSelectItem" [filter]="true" appendTo="body"
                        formControlName="Items" [style]="{ width: '100%' }">
                    </p-multiSelect>
                    <label for="float-dd">Item</label>
                </p-floatLabel>
            </div>

            <!-- Person -->
            <div class="pb-2 flex justify-content-center">
                <div class="flex items-center">
                    <p-checkbox binary="true" [(ngModel)]="includeInactive" [ngModelOptions]="{standalone: true}" (onChange)="includeInactiveChanged($event)"></p-checkbox>
                    <label class="ml-2">Include inactive</label>
                </div>
            </div>
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-multiSelect [options]="directReportsSelectItem" placeholder="Person" [filter]="true"
                        appendTo="body" formControlName="DirectReports" [style]="{ width: '100%' }">
                    </p-multiSelect>
                    <label for="float-dd">Person</label>
                </p-floatLabel>
            </div>

            <!-- Payroll Item -->
            <div style="padding-bottom: 2em">
                <p-floatLabel variant="on">
                    <p-multiSelect [options]="payrollItemsSelectItem" [filter]="true"
                        appendTo="body" formControlName="PayrollItems" [style]="{ width: '100%' }">
                    </p-multiSelect>
                    <label for="float-dd">Payroll Item</label>
                </p-floatLabel>
            </div>

            <!-- Txn Notes -->
            <div style="padding-bottom: 0.5em">
                <p-floatLabel variant="on">
                    <textarea id="float-textarea" pInputTextarea id="textArea" formControlName="note"
                        style="overflow: auto; width: 100%; height: 4em"></textarea>
                    <label for="float-dd">Notes</label>
                </p-floatLabel>
            </div>

            <!-- <button pRipple pButton label="Manual Adjustment" icon="pi pi-plus-circle"
                class="p-button-secondary" (click)="buildTable()"></button> -->

            <!-- <button pRipple pButton label="Clear" title="Clear values selected for Add" class="p-button-text"
                (click)="clearBuild()"></button> -->
        </form>

        <ng-template #footer>
            <button type="button" pButton icon="pi pi-check" class="p-button-text p-button-success" label="Confirm"
                (click)="addManualAdj()"></button>
            <button type="button" pButton icon="pi pi-times" class="p-button-text p-button-danger" label="Cancel"
                (click)="closeDialog()"></button>
        </ng-template>
    </p-dialog>
</div>

<p-messages [(value)]="companyFYNotice" [enableService]="false"></p-messages>
<div class="card">
    <p-accordion>
        <p-accordionTab header="Filter" [selected]="true">
            <form [formGroup]="filterFormGroup" #buildForm="ngForm" id="filterForm">
                <p-toolbar>
                    <!-- Direct or Indirect Toggle -->
                    <!-- <div>
                        <label style="
                                padding-right: 7px;
                                padding-left: 14px;
                                margin-bottom: 0px;
                                vertical-align: middle;
                            ">Direct</label>
                        <p-inputSwitch [style]="{ 'vertical-align': 'middle' }" formControlName="DoI"></p-inputSwitch>
                        <label style="
                                vertical-align: middle;
                                margin-bottom: 0px;
                                margin-top: 0px;
                            ">Indirect</label>
                    </div> -->

                    <div class="flex items-center">
                        <p-radioButton name="direct" value="direct" formControlName="direct" inputId="direct">
                        </p-radioButton>
                        <label class="radio-label" for="direct">Direct</label>
                    </div>
                    <div class="flex items-center">
                        <p-radioButton name="indirect" value="indirect" formControlName="indirect" inputId="indirect">
                        </p-radioButton>
                        <label class="radio-label" for="indirect">Indirect</label>
                    </div>

                    <!-- Manual Adjustment Date -->
                    <p-floatLabel variant="on">
                        <p-datepicker selectionMode="range" [monthNavigator]="true" [yearNavigator]="true"
                            yearRange="2000:2030" appendTo="body" [showIcon]="false" id="asofdate"
                            formControlName="Range" [minDate]="CSFYStart" [maxDate]="CSFYEnd">
                        </p-datepicker>
                        <label for="float-dd">Date Range</label>
                    </p-floatLabel>

                    <!-- Contract -->
                    <p-floatLabel variant="on">
                        <p-multiSelect [style]="{ 'min-width': '9em' }"  maxSelectedLabels="1"
                            appendTo="body" [options]="contractsFilterSelectItem" [filter]="true"
                            formControlName="Contracts">
                        </p-multiSelect>
                        <label for="float-dd">Contract</label>
                    </p-floatLabel>

                    <!-- Task -->
                    <!-- <p-floatLabel variant="on">
                        <p-multiSelect defaultLabel="Filter" maxSelectedLabels="1" appendTo="body"
                            [options]="tasksSelectItem" [filter]="true" formControlName="Tasks">
                        </p-multiSelect>
                        <label for="float-dd">Task</label>
                    </span> -->

                    <!-- Txn Type -->
                    <!-- <p-floatLabel variant="on">
                        <p-select [options]="txnTypesSelectItem" [filter]="true" appendTo="body"
                            [autoDisplayFirst]="false" formControlName="Txntypes">
                        </p-select>
                        <label for="float-dd">Txn Type</label>
                    </span>                    -->
                </p-toolbar>
            </form>
        </p-accordionTab>
    </p-accordion>

    <p-accordion>
        <p-accordionTab [header]="manualAdjustmentsTabHeader" [selected]="true">
            <div id="manual-adjustment">
                <p-toolbar>
                    <button pButton pRipple label="Add Manual Adjustment" (click)="openDialog()"
                        class="p-button-secondary" icon="pi pi-plus-circle"></button>
                    <p-floatLabel variant="on">
                        <p-multiSelect [options]="colsCanBeHidden" [(ngModel)]="selectedColumns" optionLabel="header"
                            (onChange)="onSelectedColumnsChange($event)" selectedItemsLabel="{0} columns selected"
                            [style]="{ minWidth: '200px' }" placeholder="Show/Hide Columns" maxSelectedLabels="1"
                            appendTo="body"></p-multiSelect>
                        <label for="float-dd">Show/Hide Columns</label>
                    </p-floatLabel>
                    <button type="button" pButton pRipple icon="pi pi-download" (click)="adjTable.exportCSV()"
                        class="p-button-secondary p-mr-2" pTooltip="Download"
                        tooltipPosition="bottom"></button>

                    <form [formGroup]="calcFormGroup" #buildForm="ngForm" id="calcForm">
                        <div class="flex items-center">
                            <p-checkbox [formControl]="
                                this.calcFormGroup.controls['CalculateAmount']
                            " [binary]="true"></p-checkbox>
                            <label class="ml-2">Auto Calculate Amount</label>
                        </div>
                        <div class="flex items-center">
                            <p-checkbox [formControl]="
                                this.calcFormGroup.controls['CalculateBurden']
                            " [binary]="true"></p-checkbox>
                            <label class="ml-2">Auto Calculate Burdens</label>
                        </div>

                    </form>
                    <div class="flex items-center">
                        <p-checkbox binary="true" [(ngModel)]="includeInactive" (onChange)="includeInactiveChanged($event)"></p-checkbox>
                        <label class="ml-2">Include Inactive Persons</label>
                    </div>

                    <!-- <ef-column-search [elements]="elements"></ef-column-search> -->
                </p-toolbar>
                <p-table stripedRows #adjTable [value]="this.adjustments" scrollHeight="50vh" [scrollable]="true"
                    scrollDirection="both" editMode="row" (onEditInit_Summary)="onEditInit($event)"
                    (onRowEditSave)="onRowEditSave($event)" dataKey="Txnid" [columns]="cols" (onColResize)="onColumnResize($event)">
                    <ng-template pTemplate="emptymessage">
                        <tr style="margin-top: 1em">
                            <td colspan="6" style="text-align: center; margin-top: 1em">
                                <div class="tabulator-placeholder">
                                    <span> No Data Available </span>
                                </div>
                            </td>
                        </tr>
                    </ng-template>
                    <ng-template #header>
                        <tr>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell"></th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                <i class="pi pi-exclamation-circle" title="Status"></i>
                            </th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Adjustmentstatus">
                                Status
                                <p-sortIcon field="Adjustmentstatus" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Txndate">
                                Txn Date
                                <p-sortIcon field="Txndate" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="Txntype">
                                Type
                                <p-sortIcon field="Txntype" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="Txntype" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body" [options]="
                                                    this
                                                        .txnTypesFilterSelectItem
                                                " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <!-- <th pSortableColumn="Contractdesc" class="tabulator-colgroup-header">
                                <div class="tabulator-col-content">
                                    Contract
                                    <p-sortIcon field="Contractdesc" ariaLabel="Activate to sort"
                                        ariaLabelDesc="Activate to sort in descending order"
                                        ariaLabelAsc="Activate to sort in ascending order">
                                    </p-sortIcon>
                                </div>
                            </th> -->
                            <th pFrozenColumn [frozen]="IsColumnFrozen" pSortableColumn="TaskLongName">
                                Task
                                <p-sortIcon field="TaskLongName" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="TaskLongName" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body" [options]="
                                                    this.tasksFilterSelectItem
                                                " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="Employeelistid" *ngIf="this.EmpColumnHidden == false">
                                Person
                                <p-sortIcon field="Employeelistid" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="Employeelistid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                         <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body" [options]="
                                                    directReportsFilterSelectItem
                                                " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="Silistid" *ngIf="this.SIColumnHidden == false">
                                Item
                                <p-sortIcon field="Silistid" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="Silistid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body" [options]="
                                                    serviceItemsFilterSelectItem
                                                " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="Pilistid" *ngIf="this.PIColumnHidden == false">
                                Payroll Item
                                <p-sortIcon field="Pilistid" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="Pilistid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body" [options]="
                                                    payrollItemsFilterSelectItem
                                                " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="Costcenterid" *ngIf="this.CCColumnHidden == false">
                                Cost Center
                                <p-sortIcon field="Costcenterid" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                                <p-columnFilter field="Costcenterid" matchMode="in" display="menu" [showMatchModes]="false" [showOperator]="false"
                                    [showAddButton]="false" class="ml-auto">
                                    <ng-template #filter let-value let-filter="filterCallback">
                                        <p-multiSelect defaultLabel="Filter"
                                                maxSelectedLabels="1" appendTo="body" [options]="
                                                    userGroupsFilterSelectItem
                                                " [filter]="true" styleClass="w-full" [ngModel]="value" (ngModelChange)="filter($event)">
                                            </p-multiSelect>
                                    </ng-template>
                                </p-columnFilter>
                            </th>
                            <th pSortableColumn="Billablestatus" *ngIf="this.BillableColumnHidden == false">
                                Billable Status
                                <p-sortIcon field="Billablestatus" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Hoursworked">
                                Hours
                                <p-sortIcon field="Hoursworked" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsDirectFilter == true" pSortableColumn="Invoiceamount">
                                Invoice Amount
                                <p-sortIcon field="Invoiceamount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsDirectFilter == true" pSortableColumn="Frcost">
                                FR Invoice
                                <p-sortIcon field="Frcost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsDirectFilter == true" pSortableColumn="Ohcost">
                                OH Invoice
                                <p-sortIcon field="Ohcost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsDirectFilter == true" pSortableColumn="Mhcost">
                                MH Invoice
                                <p-sortIcon field="Mhcost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsDirectFilter == true" pSortableColumn="Gacost">
                                GA Invoice
                                <p-sortIcon field="Gacost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th *ngIf="this.IsDirectFilter == true" pSortableColumn="Feecost">
                                Fee Invoice
                                <p-sortIcon field="Feecost" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Actualamount">
                                Incurred Amount
                                <p-sortIcon field="Actualamount" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Frcostebr" *ngIf="this.IsDirectFilter == true">
                                FR Incurred
                                <p-sortIcon field="Frcostebr" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Ohcostebr"
                                *ngIf="this.IsDirectFilter == true">
                                OH Incurred
                                <p-sortIcon field="Ohcostebr" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Mhcostebr"
                                *ngIf="this.IsDirectFilter == true">
                                MH Incurred
                                <p-sortIcon field="Mhcostebr" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Gacostebr"
                                *ngIf="this.IsDirectFilter == true">
                                GA Incurred
                                <p-sortIcon field="Gacostebr" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th pSortableColumn="Feecostebr"
                                *ngIf="this.IsDirectFilter == true">
                                Fee Incurred
                                <p-sortIcon field="Feecostebr" ariaLabel="Activate to sort"
                                    ariaLabelDesc="Activate to sort in descending order"
                                    ariaLabelAsc="Activate to sort in ascending order">
                                </p-sortIcon>
                            </th>
                            <th>
                                Notes
                            </th>
                            <th class="p-header-cell delete-cell">

                            </th>
                        </tr>
                    </ng-template>
                    <ng-template #body let-adj let-ri="rowIndex" let-edit="editing">
                        <tr [pEditableRow]="adj">
                            <td pFrozenColumn [frozen]="IsColumnFrozen" class="edit-cell">
                                <button *ngIf="
                                        !edit &&
                                        (!editing?.Txnid ||
                                            !editing?.Txnid === adj?.Txnid)
                                    " pButton pRipple type="button" pInitEditableRow icon="pi pi-pencil"
                                    (click)="onRowEditInit(adj)" class="p-button-rounded p-button-text"
                                    style="height: 1.4rem; width: 1.4rem" title="Edit"></button>
                                <button *ngIf="edit" pButton pRipple type="button" pSaveEditableRow icon="pi pi-check"
                                    (click)="onRowEditSave(adj)" class="p-button-rounded p-button-text p-button-success"
                                    style="
                                        margin-right: 0.5em;
                                        height: 1.4rem;
                                        width: 1.4rem;
                                    "></button>
                                <button *ngIf="edit" pButton pRipple type="button" pCancelEditableRow icon="pi pi-times"
                                    (click)="onRowEditCancel(adj)"
                                    class="p-button-rounded p-button-text p-button-danger"
                                    style="height: 1.4rem; width: 1.4rem"></button>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen" class="status-cell">
                                <a (click)="ShowError.next(adj)">
                                    <div>
                                        <ef-status-icon [status]="
                                                adj?.Status?.StatusCode
                                            " [message]="adj?.Status?.Message">
                                        </ef-status-icon>
                                    </div>
                                </a>
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                {{ adj.Adjustmentstatus }}
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                {{ moment(adj.Txndate).format('MM/DD/YYYY') }}
                            </td>
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="
                                                txnTypesInTableSelectItem as items
                                            ">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Txntype"></ef-dropdown>
                                            <!-- <p-select [options]="txnTypesInTableSelectItem" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false" [(ngModel)]="adj.Txntype">
                                            </p-select> -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div *ngIf="adj.Txntype != null">
                                            {{ this.findTxnType(adj.Txntype) }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <!-- <td>
                                {{ adj.Contractdesc }}
                            </td>                           -->
                            <td pFrozenColumn [frozen]="IsColumnFrozen">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="
                                                this
                                                    .tasksInTableSelectItem as items
                                            ">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Tasklistid"></ef-dropdown>
                                            <!-- <p-select [options]="items" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false" [(ngModel)]="adj.Tasklistid"
                                                [placeholder]="
                                                    this.findTask(adj)
                                                ">
                                            </p-select> -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div [title]="this.findTask(adj)" *ngIf="adj.Tasklistid != null">
                                            {{ this.findTask(adj) }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.EmpColumnHidden == false">
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="
                                                directReportsSelectItem as items
                                            ">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Employeelistid"></ef-dropdown>
                                            <!-- <p-select [options]="items" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false"
                                                [(ngModel)]="adj.Employeelistid">
                                            </p-select> -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div [title]="this.findEmployee(adj)" *ngIf="adj.Employeelistid != null">
                                            {{ this.findEmployee(adj) }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.SIColumnHidden == false">
                                <!--Item-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="serviceItemsSelectItem as items">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Silistid"></ef-dropdown>
                                        </div>


                                        <!-- <p-select [options]="items" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false" [(ngModel)]="adj.Silistid">
                                            </p-select> -->
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div [title]="this.findServiceItem(adj)" *ngIf="adj.Silistid != null">
                                            {{ this.findServiceItem(adj) }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.PIColumnHidden == false">
                                <!--Payroll Item-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="
                                                payrollItemsSelectItem as items
                                            ">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Pilistid"></ef-dropdown>
                                            <!-- <p-select [options]="items" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false" [(ngModel)]="adj.Pilistid">
                                            </p-select> -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div [title]="this.findPayrollItem(adj)" *ngIf="adj.Pilistid != null">
                                            {{ this.findPayrollItem(adj) }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.CCColumnHidden == false">
                                <!--Cost Center-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="
                                                userGroupsInTableSelectItem as items
                                            ">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Costcenterid"></ef-dropdown>
                                            <!-- <p-select [options]="items" [virtualScroll]="true" [filter]="false"
                                                appendTo="body" [autoDisplayFirst]="false"
                                                [(ngModel)]="adj.Costcenterid">
                                            </p-select> -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <div [title]="
                                                this.findCostCenterName(
                                                    adj.Costcenterid
                                                )
                                            " *ngIf="adj.Costcenterid != null">
                                            {{
                                                this.findCostCenterName(
                                                    adj.Costcenterid
                                                )
                                            }}
                                        </div>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.BillableColumnHidden == false">
                                <!--Billable Status-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <div *ngIf="billableStatusSelectItem as items">
                                            <ef-dropdown [items]="items" [rowData]="adj" property="Billablestatus"></ef-dropdown>
                                            <!-- <p-select [options]="items" [filter]="false" appendTo="body"
                                                [autoDisplayFirst]="false" [(ngModel)]="adj.Billablestatus">
                                            </p-select> -->
                                        </div>
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Billablestatus }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <!--Hoursworked-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Hoursworked" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Hoursworked }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Invoiceamount-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Invoiceamount" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Invoiceamount }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Frcost-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Frcost" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Frcost }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Ohcost-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Ohcost" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Ohcost }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Mhcost-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Mhcost" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Mhcost }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Gacost-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Gacost" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Gacost }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Feecost-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Feecost" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Feecost }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <!--Actualamount-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Actualamount" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Actualamount }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Frcostebr-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Frcostebr" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Frcostebr }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Ohcostebr-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Ohcostebr" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Ohcostebr }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Mhcostebr-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Mhcostebr" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Mhcostebr }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Gacostebr-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Gacostebr" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Gacostebr }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td *ngIf="this.IsDirectFilter == true">
                                <!--Feecostebr-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.Feecostebr" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        {{ adj.Feecostebr }}
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td>
                                <!--TxnNotes-->
                                <p-cellEditor>
                                    <ng-template pTemplate="input">
                                        <input pInputText type="text" [(ngModel)]="adj.TxnNotes" />
                                    </ng-template>
                                    <ng-template pTemplate="output">
                                        <label [title]="adj.TxnNotes">{{
                                            adj.TxnNotes
                                        }}</label>
                                    </ng-template>
                                </p-cellEditor>
                            </td>
                            <td class="delete-cell">
                                <button class="p-button-danger p-button-rounded p-button-text" pButton type="button"
                                    icon="pi pi-trash" (click)="onadjDelete(adj)"></button>
                            </td>
                        </tr>
                    </ng-template>
                </p-table>
            </div>
        </p-accordionTab>
    </p-accordion>
</div>
